import {forwardRef} from "react";
import {Tooltip} from "@mantine/core";
import {t} from "i18next";
import UndoIcon from "../../../../assets/undo.svg?react";
import classes from "./form-elements.module.css";

interface UndoButtonProps {
    onClick: () => void;
}

export const UndoButton = forwardRef<HTMLButtonElement, UndoButtonProps>(
    ({onClick}, ref) => (
        <Tooltip label={t("Action.Reset", "Nullstill")}>
            <button
                ref={ref}
                type="button"
                className={classes.undoButton}
                onClick={onClick}
                data-pw="dg-undo-btn"
                aria-label={t("Action.Reset", "Nullstill")}
            >
                <UndoIcon />
            </button>
        </Tooltip>
    )
);

UndoButton.displayName = "UndoButton";
